import { withInstall } from '@park-ui/utils'

import Pagination from './src/pagination'

export const ElPagination = withInstall(Pagination)
export default ElPagination

export * from './src/pagination'
